import type { JSX } from 'react'
export function ChatIcon ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      className={className}
      width='162' height='162' viewBox='0 0 162 162' fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_di_791_661)'>
        <rect x='39' y='31' width='84' height='84' rx='42' className='fill-success-500' />
        <path
          opacity='0.3'
          d='M96.75 68.5C98.5402 68.5 100.257 69.2112 101.523 70.477C102.789 71.7429 103.5 73.4598 103.5 75.25V82C103.5 83.7902 102.789 85.5071 101.523 86.773C100.257 88.0388 98.5402 88.75 96.75 88.75V90.9235C96.75 93.3085 93.969 94.6113 92.1375 93.0835L86.9355 88.75H81C79.2098 88.75 77.4929 88.0388 76.227 86.773C74.9612 85.5071 74.25 83.7902 74.25 82V75.25C74.25 73.4598 74.9612 71.7429 76.227 70.477C77.4929 69.2112 79.2098 68.5 81 68.5H96.75Z'
          fill='#757575'
        />
        <path
          d='M90 55C91.7902 55 93.5071 55.7112 94.773 56.977C96.0388 58.2429 96.75 59.9598 96.75 61.75V64H78.75C76.3631 64 74.0739 64.9482 72.386 66.636C70.6982 68.3239 69.75 70.6131 69.75 73V82C69.75 84.349 70.65 86.491 72.126 88.093L69.75 89.875C67.896 91.2655 65.25 89.9425 65.25 87.625V84.25C63.4598 84.25 61.7429 83.5388 60.477 82.273C59.2112 81.0071 58.5 79.2902 58.5 77.5V61.75C58.5 59.9598 59.2112 58.2429 60.477 56.977C61.7429 55.7112 63.4598 55 65.25 55H90Z'
          fill='white'
        />
      </g>
      <defs>
        <filter
          id='filter0_di_791_661' x='0' y='0' width='162' height='162' filterUnits='userSpaceOnUse'
          color-interpolation-filters='sRGB'
        >
          <feFlood flood-opacity='0' result='BackgroundImageFix' />
          <feColorMatrix
            in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feMorphology radius='6' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_791_661' />
          <feOffset dy='8' />
          <feGaussianBlur stdDeviation='16.5' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.0117647 0 0 0 0 0.819608 0 0 0 0 0.423529 0 0 0 0.18 0' />
          <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_791_661' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_791_661' result='shape' />
          <feColorMatrix
            in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dx='-2' dy='2' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
          <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0' />
          <feBlend mode='normal' in2='shape' result='effect2_innerShadow_791_661' />
        </filter>
      </defs>
    </svg>
  )
}
